<template>
	<div class='percentage_area'>
		<h3 class='plot_title'>{{name}}</h3>
		<svg :id='id' class='percentage_viz' width='440px' height='72px'></svg>
		<div class='perc_legend'>
			<div class='legend_icons'>
				<svg class='legend_svg' width='16px' height='100px'>
					<rect width='16' height='16' x='0' y='0' fill='#90EE90'/>
					<rect width='16' height='16' x='0' y='36' fill='#0D256E'/>
					<rect width='16' height='2' x='0' y='80' fill='#87CEEB'/>
				</svg>
			</div>
			<div class='legend_pars'>	
				<p :id='id+"_first_label"' class='legend_p'>prova1</p>				
				<p :id='id+"_second_label"' class='legend_p'>prova2</p>
				<p :id='id+"_mean_label"' class='legend_p'>prova3</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name : 'Percentagearea', 
	props : [
		'id',
		'name',
		'district'
	],
	mounted() {
		let component = this
		component.draw()
	},
	methods : {
		draw() {
			const name = this.name,
				id = this.id,
				height = 72,
				width = 440
			let dataset = require('/src/assets/final_df.json'),
				district = this.district.replace(' ', '_'),
				walkable_km2 = dataset[district]['walkable_km2'].toFixed(1), 
				veg_km2 = dataset[district]['veg_km2'].toFixed(1),
				veg_perc = dataset[district]['veg_perc'].toFixed(1),
				mean_veg_perc = dataset['mean']['veg_perc'].toFixed(1),
				walkable_m2_per_person = dataset[district]['walkable_m2_per_person'].toFixed(1),
				veg_m2_per_person = dataset[district]['veg_m2_per_person'].toFixed(1),
				perc_h = 48,
				margin = ({top: 10, right: 20, bottom: 30, left: 20})

			let svg = d3.select(`#${id}`)

			let x = d3.scaleLinear()
				.domain([0, 100])
				.range([margin.left, width - margin.right - margin.left])

			let percentage = svg.append('g')
				.attr('class', 'perc_group')
				
			percentage
				.append('rect')
				.attr('x', x(0))
				.attr('y', margin.top)
				.attr('height', perc_h)
				.attr('width', x(100))
				.attr('fill', '#0D256E')
				.on('mouseover', function(d,i){
				$(this).attr('fill', '#12349C')
				$(this).attr('cursor', 'pointer')
				})
				.on('mouseout', function(d,i){
				$(this).attr('fill', '#0D256E')
				// $(this).attr('cursor', 'auto')
				$('#tooltip').css('opacity', 0)
				})

			percentage
				.append('rect')
				.attr('x', x(0))
				.attr('y', margin.top)
				.attr('height', perc_h)
				.attr('width', x(veg_perc))
				.attr('fill', '#90EE90')
				.on('mouseover', function(d,i){
				$(this).attr('fill', '#bcf5bc')
				$(this).attr('cursor', 'pointer')
				})
				.on('mouseout', function(d,i){
				$(this).attr('fill', '#90EE90')
				// $(this).attr('cursor', 'auto')
				$('#tooltip').css('opacity', 0)
				})

			percentage
				.append('rect')
				.attr('x', x(0) + x(mean_veg_perc))
				.attr('y', margin.top)
				.attr('height', perc_h)
				.attr('width', 2)
				.attr('fill', '#87CEEB')

			percentage
				.append('text')
				.attr('x', x(1))
				.attr('y', margin.top + 12 + 1)
				.style('font-size', '10.5px')
				.attr('fill', '#0D256E')
				.text(veg_perc + '%')


			$(`#${id}_first_label`).html('Superficie calpestabile coperta da vegetazione: ' + veg_km2 + ' km^2 (' + veg_m2_per_person + ' m^2 per abitante del quartiere)')
			$(`#${id}_second_label`).html('Superficie calpestabile: ' + walkable_km2 + ' km^2 (' + walkable_m2_per_person + ' m^2 per abitante del quartiere)')
			$(`#${id}_mean_label`).html('Media superficie calpestabile coperta da vegetazione per quartiere: ' + mean_veg_perc + '%')
		}
	}
}
</script>
<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
	.percentage_area {
/*		position: absolute;*/
		background-color: #FFF;
		padding-bottom: 12px;
/*		top: 85px;*/
/*		left: 360px;*/
		z-index: 2;
	}
	.percentage_viz {
		display: block;
	}
	.perc_legend {
		width: calc(100% - 20px);
		text-align: left;
		margin-left: 20px;
		display: flex;
	}
	.legend_pars {
		margin-left: 4px;
	}
	.legend_pars p {;
		font-size: 12.5px;
		width: calc(400px - 64px);
	}
	.legend_pars p {
		margin-bottom: 7px;
	}
	.legend_pars p:last-child {
		margin-bottom: 0px;
	}
</style>